import { render, staticRenderFns } from "./EmulatorScreenCustomization.vue?vue&type=template&id=1835520a&scoped=true"
import script from "./EmulatorScreenCustomization.vue?vue&type=script&lang=js"
export * from "./EmulatorScreenCustomization.vue?vue&type=script&lang=js"
import style0 from "./EmulatorScreenCustomization.vue?vue&type=style&index=0&id=1835520a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1835520a",
  null
  
)

export default component.exports